import Button from 'src/components/Button';
import styled, { css } from 'styled-components';

interface SearchContainerProps {
  opened: boolean;
}

const SearchContainer = styled.div<SearchContainerProps>`
  position: relative;
  width: 100%;
  max-width: 300px;
  margin-right: 24px;
  border: 2px solid var(--secondary-color);
  border-radius: 50px;

  /* ${(props) => props.opened &&
    css`
      width: 40px;
      & > input {
        padding: 8px !important;
      }

      & > svg,
      path,
      circle {
        stroke: var(--primary-color) !important;
        color: var(--primary-color) !important;
      }
    `
  } */
`;

const SearchInput = styled.input`
  display: flex;
  align-items: center;
  padding: 8px 16px 8px 36px;
  width: 100%;

  border: none;
  outline: none;
  border-radius: 50px;
  color: var(--text-color);
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  z-index: 8;

  &::placeholder {
    color: var(--text-color);
  }
`;

const SearchButton = styled(Button)`
  position: absolute;
  top: 2px;
  left: 2px;
  justify-content: center;
  align-items: center;
`;

export { SearchContainer, SearchInput, SearchButton };
